module.exports = __webpack_public_path__ + "img/banner2.932d614c.png";